// NOTE: These keys are set on the `BASE_CONFIG` object by the z/z base Django template:
// https://github.com/zapier/zapier/blob/develop/web/backend/zapier/templates/base.html#L94-L95
// If you are using this component outside of z/z these need to be set explicitly
export const apiKeys = {
  stripePubKey:
    typeof window !== 'undefined'
      ? window.BASE_CONFIG?.stripePubApiKey
      : undefined,
  braintreePubKey:
    typeof window !== 'undefined'
      ? window.BASE_CONFIG?.braintreePubApiKey
      : undefined,
};
